export default __webpack_public_path__ + "static/media/302.cce7ec30.gif";